export const isSamsungBrowser = (ua: string) => {
	return /SamsungBrowser/i.test(ua);
};
